import StandardChip from './StandardChip';
export default StandardChip;
